// Malaysian states and their areas (townships / districts)
export const STATE_TO_AREAS = {
  "Kuala Lumpur": [
    "Bukit Bintang",
    "KLCC",
    "Chow Kit",
    "Brickfields",
    "Bangsar",
    "Mont Kiara",
    "Desa ParkCity",
    "Sri Petaling",
    "Cheras",
    "Kepong",
    "Sentul",
    "Wangsa Maju",
    "Setapak",
    "Titiwangsa",
    "Setiawangsa",
    "Ampang",
    "Taman Tun Dr Ismail",
    "Damansara",
    "Sri Hartamas",
    "Segambut",
    "Jalan Ipoh",
    "Jalan Kuching",
    "Mid Valley",
    "KL Sentral",
    "Desa Sri Hartamas",
    "Bukit Jalil",
  ],
  Selangor: [
    "Petaling Jaya",
    "Subang Jaya",
    "Shah Alam",
    "Klang",
    "Puchong",
    "Cheras",
    "Kajang",
    "Ampang",
    "Selayang",
    "Kepong",
    "Putrajaya",
    "Seri Kembangan",
    "Sepang",
    "Bangi",
    "Rawang",
    "Batu Caves",
    "Serdang",
    "Ara Damansara",
    "Damansara",
    "Damansara Perdana",
    "Damansara Damai",
    "Damansara Utama",
    "Kota Kemuning",
    "Sunway",
    "USJ",
    "Cyberjaya",
    "Semenyih",
    "Hulu Langat",
    "Kuala Selangor",
    "Tanjung Karang",
    "Jenjarom",
    "Banting",
    "Morib",
    "Sabak Bernam",
    "Sekinchan",
    "Kelang Lama",
  ],
  Johor: [
    "Johor Bahru",
    "Iskandar Puteri",
    "Pasir Gudang",
    "Muar",
    "Batu Pahat",
    "Skudai",
    "Kluang",
    "Segamat",
    "Mersing",
    "Pontian",
    "Kulai",
    "Senai",
    "Tampoi",
    "Masai",
    "Kota Tinggi",
    "Desaru",
    "Gelang Patah",
    "Nusajaya",
    "Larkin",
    "Pelangi",
    "Tebrau",
  ],
  Penang: [
    "George Town",
    "Butterworth",
    "Bayan Lepas",
    "Bukit Mertajam",
    "Gelugor",
    "Tanjung Tokong",
    "Tanjung Bungah",
    "Batu Ferringhi",
    "Air Itam",
    "Balik Pulau",
    "Kepala Batas",
    "Sungai Jawi",
    "Nibong Tebal",
    "Perai",
    "Seberang Jaya",
    "Bertam",
    "Sg. Ara",
    "Prai",
  ],
  Perak: [
    "Ipoh",
    "Taiping",
    "Kampar",
    "Teluk Intan",
    "Manjung",
    "Lumut",
    "Sitiawan",
    "Batu Gajah",
    "Kuala Kangsar",
    "Parit Buntar",
    "Tanjung Malim",
    "Sungai Siput",
    "Slim River",
    "Bidor",
    "Gerik",
    "Lenggong",
  ],
  Melaka: [
    "Melaka Tengah",
    "Alor Gajah",
    "Jasin",
    "Ayer Keroh",
    "Bukit Katil",
    "Merlimau",
    "Masjid Tanah",
    "Tanjung Kling",
  ],
  "Negeri Sembilan": [
    "Seremban",
    "Nilai",
    "Port Dickson",
    "Bahau",
    "Rembau",
    "Kuala Pilah",
    "Tampin",
    "Rantau",
    "Senawang",
    "Mantin",
  ],
  Pahang: [
    "Kuantan",
    "Temerloh",
    "Bentong",
    "Raub",
    "Jerantut",
    "Pekan",
    "Rompin",
    "Cameron Highlands",
    "Genting Highlands",
    "Fraser's Hill",
    "Mentakab",
    "Bera",
    "Maran",
  ],
  Terengganu: [
    "Kuala Terengganu",
    "Kemaman",
    "Dungun",
    "Marang",
    "Besut",
    "Setiu",
    "Hulu Terengganu",
    "Cukai",
    "Kerteh",
  ],
  Kelantan: [
    "Kota Bharu",
    "Wakaf Baru",
    "Pasir Mas",
    "Tanah Merah",
    "Kuala Krai",
    "Gua Musang",
    "Bachok",
    "Pasir Puteh",
    "Tumpat",
    "Machang",
    "Jeli",
  ],
  Kedah: [
    "Alor Setar",
    "Sungai Petani",
    "Langkawi",
    "Kulim",
    "Baling",
    "Pendang",
    "Pokok Sena",
    "Kota Setar",
    "Kubang Pasu",
    "Padang Terap",
    "Bandar Baharu",
    "Yan",
  ],
  Perlis: ["Kangar", "Arau", "Padang Besar", "Wang Kelian"],
  Sabah: [
    "Kota Kinabalu",
    "Sandakan",
    "Tawau",
    "Lahad Datu",
    "Keningau",
    "Semporna",
    "Beaufort",
    "Kudat",
    "Kota Belud",
    "Ranau",
    "Papar",
    "Penampang",
    "Putatan",
    "Tuaran",
    "Kota Marudu",
    "Beluran",
    "Likas",
    "Api-Api",
  ],
  Sarawak: [
    "Kuching",
    "Miri",
    "Sibu",
    "Bintulu",
    "Limbang",
    "Sarikei",
    "Sri Aman",
    "Kapit",
    "Mukah",
    "Betong",
    "Serian",
    "Kota Samarahan",
    "Lawas",
    "Marudi",
    "Bau",
    "Lundu",
    "Padawan",
  ],
  Labuan: ["Labuan", "Victoria"],
};

export const ALL_STATES = Object.keys(STATE_TO_AREAS).sort((a, b) =>
  a.localeCompare(b, undefined, { sensitivity: "base" }),
);
export const ALL_AREAS = Object.values(STATE_TO_AREAS)
  .flat()
  .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
